import React, { Component } from 'react';

interface IProps {
    hideLabel?: boolean;
    showDisclaimer?: boolean;
    customDisclaimer?: any;
}

export class LenderRow extends Component<IProps, any> {

    render() {
        return (
            <div className='box chartreuse mt-2'>
                {(this.props.hideLabel ?? false) === false &&
                <>
                <h2>We work with all major providers</h2>
                <p>Follow a few simple steps, and we’ll show you all viable options from all major providers</p>
                </>
                }
                <div className='row mb-0 pb-0'>
                    <div className='lenders'></div>
                </div>
                <div className='row mt-0 pt-0'>
                    <div className='insurance'></div>
                </div>
                {this.props.showDisclaimer && !this.props.customDisclaimer &&
                    <p className='s'>Disclaimer: Our calculators give indicative figures and are based on 35 year term unless another is selected. They are in no way intended to constitute an offer. Such calculations are made on the presumption that the
                    information supplied by you is accurate and is subject to approval by the actual lender. Rates include Green rate options which only apply if BER is B3 or
                    above. This web page is for illustrative purposes only, so as to give you, the borrower, an overview of the potential cost of borrowing.</p>
                }
                {this.props.showDisclaimer && this.props.customDisclaimer &&
                    <p className='s'>{this.props.customDisclaimer}</p>
                }
            </div>
        );
    }
}
